import { VentasFacturasEjecutivo } from "../../components";

const VentasFactura = () => <VentasFacturasEjecutivo />;

export default VentasFactura;
